import axios from "axios";
import React, { Component } from "react";
import { browserHistory } from "react-router";
import { CLIENT_ID, TOKEN, USER_ID } from "../../utils/constants/localstoregeConstants";

class AutoLogin extends Component {
  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("token");
    const userId = queryParams.get("userid");
    const luserId = queryParams.get("luserid");
    
    // Try multiple variations of clientId parameter name
    const clientId = queryParams.get("clientId") || 
                     queryParams.get("clientid") || 
                     queryParams.get("client_id") ||
                     queryParams.get("ClientId");

    var post = {
      user_id: userId,
    };
    
    if (id && id !== "" && userId && userId != "") {
      axios
        .post("/api/laundry_auto_login", post, { headers: { "token-id": id, "user-id": luserId, "device-type": "AML9327483" } })
        .then((response) => {
          if (response.data != "" && response.data != null) {
            const luserIdValue = response.data.result.luser_id;
            const tokenIdValue = response.data.result.token_id;
            const clientIdFromApi = response.data.result.client_id || response.data.result.clientId;
            
            localStorage.setItem(USER_ID, luserIdValue);
            localStorage.setItem(TOKEN, tokenIdValue);
            
            // Set CLIENT_ID - try URL param first, then API response
            const finalClientId = clientId || clientIdFromApi;
            if (finalClientId && finalClientId !== "null" && finalClientId !== "") {
              localStorage.setItem(CLIENT_ID, finalClientId);
            }
            
            browserHistory.push("/questions");
            window.location.reload();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  render() {
    return <div></div>;
  }
}

export default AutoLogin;



// WEBPACK FOOTER //
// ./src/views/autoLogin/index.js